import { faBug, faShieldAlt } from '@fortawesome/free-solid-svg-icons'
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons'
import { faArrowDown } from '@fortawesome/free-solid-svg-icons'
import { faAngleRight } from '@fortawesome/free-solid-svg-icons'
import { faArrowUp } from '@fortawesome/free-solid-svg-icons'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import { faBell } from '@fortawesome/free-solid-svg-icons'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { faChevronUp } from '@fortawesome/free-solid-svg-icons'
import { faCircle } from '@fortawesome/free-solid-svg-icons'
import { faClipboardList } from '@fortawesome/free-solid-svg-icons'
import { faCog } from '@fortawesome/free-solid-svg-icons'
import { faCubes } from '@fortawesome/free-solid-svg-icons'
import { faDna } from '@fortawesome/free-solid-svg-icons'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { faEquals } from '@fortawesome/free-solid-svg-icons'
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'
import { faFile, faFileImage, faWindowMinimize } from '@fortawesome/free-solid-svg-icons'
import { faFileUpload } from '@fortawesome/free-solid-svg-icons'
import { faFilter } from '@fortawesome/free-solid-svg-icons'
import { faFolder } from '@fortawesome/free-solid-svg-icons'
import { faGlobeEurope } from '@fortawesome/free-solid-svg-icons'
import { faGreaterThan } from '@fortawesome/free-solid-svg-icons'
import { faGreaterThanEqual } from '@fortawesome/free-solid-svg-icons'
import { faInfo } from '@fortawesome/free-solid-svg-icons'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { faLessThan } from '@fortawesome/free-solid-svg-icons'
import { faLessThanEqual } from '@fortawesome/free-solid-svg-icons'
import { faLink } from '@fortawesome/free-solid-svg-icons'
import { faMicroscope } from '@fortawesome/free-solid-svg-icons'
import { faMinus } from '@fortawesome/free-solid-svg-icons'
import { faNotEqual } from '@fortawesome/free-solid-svg-icons'
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons'
import { faPenSquare } from '@fortawesome/free-solid-svg-icons'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { faProjectDiagram } from '@fortawesome/free-solid-svg-icons'
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import { faSave } from '@fortawesome/free-solid-svg-icons'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { faStar } from '@fortawesome/free-solid-svg-icons'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { faUnlink } from '@fortawesome/free-solid-svg-icons'
import { faHome } from '@fortawesome/free-solid-svg-icons'
import { faUser } from '@fortawesome/free-solid-svg-icons'
import { faUsersCog } from '@fortawesome/free-solid-svg-icons'
import { faWindowClose } from '@fortawesome/free-solid-svg-icons'
import { faWrench } from '@fortawesome/free-solid-svg-icons'
import {
  faAngleDoubleRight,
  faDownload,
  faExternalLinkAlt,
  faSitemap,
  faUpload,
} from '@fortawesome/free-solid-svg-icons'
import {
  faAngleDoubleLeft,
  faArrowRight,
  faExclamation,
  faExclamationTriangle,
  faFolderOpen,
} from '@fortawesome/free-solid-svg-icons'
import {
  faClone,
  faDatabase,
  faEllipsisH,
  faEllipsisV,
  faExpandArrowsAlt,
  faPaperclip,
  faTh,
} from '@fortawesome/free-solid-svg-icons'
export const FONT_AWESOME_ICONS = [
  faCalendarAlt,
  faClipboardList,
  faFilter,
  faQuestionCircle,
  faExclamationCircle,
  faTh,
  faMicroscope,
  faMinus,
  faBars,
  faGlobeEurope,
  faEnvelope,
  faCubes,
  faBell,
  faCog,
  faSignOutAlt,
  faDna,
  faPlus,
  faSearch,
  faTimesCircle,
  faTimes,
  faCheck,
  faCheckCircle,
  faTrash,
  faUser,
  faUsersCog,
  faAngleRight,
  faCircle,
  faProjectDiagram,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faLink,
  faUnlink,
  faArrowUp,
  faArrowDown,
  faArrowRight,
  faFolder,
  faWindowClose,
  faLessThan,
  faLessThanEqual,
  faEquals,
  faGreaterThan,
  faGreaterThanEqual,
  faNotEqual,
  faSpinner,
  faWrench,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faFileUpload,
  faStar,
  faPencilAlt,
  faSave,
  faPenSquare,
  faEye,
  faEyeSlash,
  faWindowMinimize,
  faEllipsisV,
  faEllipsisH,
  faClone,
  faPaperclip,
  faLink,
  faCog,
  faExpandArrowsAlt,
  faDatabase,
  faFile,
  faFileImage,
  faFolderOpen,
  faHome,
  faExclamation,
  faExclamationTriangle,
  faInfoCircle,
  faInfo,
  faLink,
  faExternalLinkAlt,
  faSitemap,
  faUpload,
  faDownload,
  faBug,
  faShieldAlt,
]
